/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import Card, { CardSection } from '../../../components/card/Card';
import { CollapsibleCard } from '../../../components/card/CollapsibleCard';
import PolicyText from '../../../components/PolicyText.connected';
import LegalDocumentLinks from '../../../components/LegalDocumentLinks';
import { TextLink } from '../../../components/TextLink';
import Spacer from '../../../components/Spacer';
import { withIntl } from '../../../../utilities/localizedUtil';
import { ProfileThemedPrimaryButton } from '../../../components/buttons/Buttons';
import PrivacyHeader from '../../../components/PrivacyHeader';
import { BackpackThemeMarkdown } from '../../../components/Markdown';
import { ScrollAwareScroller } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import ContentWrapper from '../../../components/ContentWrapper';
import { PolicyName } from '../../../../models/PolicyModel';
import AppUtils from '../../../../utilities/AppUtils';

interface Props {
  title: {
    id: string;
    values?: object;
  };
  onWithdrawConsent(): void;
  onAccept(): void;
  intl: any;
}

export class ViewGroupConsentClass extends React.Component<Props, {}> {

  static scrollAcceptButtonIntoView() {
    const acceptButton = document.querySelector('#groupinfoprivacy-accept-button > button');
    document.getElementById('groupinfoprivacy-accept-button').scrollIntoView();
    AppUtils.addFlashToElement(acceptButton);
  }

  render() {
    const { title, onWithdrawConsent, onAccept, intl } = this.props;
    const languageCode = intl.locale;
    return (
      <ScrollAwareScroller>
        <AppHeaderScrollableText {...title} />

        <ContentWrapper>

          <Card>
            <PolicyText name={PolicyName.GROUP_CONSENT} languageCode={languageCode}>
              {
                ({ summary }) => (
                  <CollapsibleCard
                    collapsedContent={<PrivacyHeader />}
                    isCollapsible={false}
                    defaultCollapsed={false}
                  >
                    <CardSection hasBorder={false}>
                      <h3 className="font-headline"><FormattedMessage id="groupJoinConsent.heading.text" /></h3>

                      <Spacer size="6" />
                      <BackpackThemeMarkdown text={summary} />

                      <Spacer size="9" />

                      <LegalDocumentLinks.GroupConsent className="font-footnote font-color-rb-dark-accent">
                        <FormattedMessage id="privacy.seeFullGroupConsent.button.label" />
                      </LegalDocumentLinks.GroupConsent>
                    </CardSection>
                  </CollapsibleCard>
                )
              }
            </PolicyText>
          </Card>

          <div id="groupinfoprivacy-accept-button">
            <ProfileThemedPrimaryButton className="profile-background-color-accent font-color-white" type={null} size="wide" onClick={onAccept}>
              <FormattedMessage id="privacy.doConsent.button.label" />
            </ProfileThemedPrimaryButton>
          </div>

          <Spacer size="12" />

          <TextLink className="util-inset-card-margin util-inset-listitem-frame-padding font-subhead font-color-gsMiddle" style={{ display: 'block', marginBottom: 18, textDecoration: 'underline' }} onClick={onWithdrawConsent}>
            <FormattedMessage id="privacy.dontConsent.button.label" />
          </TextLink>

        </ContentWrapper>

      </ScrollAwareScroller>
    );
  }
}

export default withIntl(ViewGroupConsentClass);
